module.exports = __webpack_public_path__ + "img/women-economic.ef710aca.svg";